
import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import RenderTextField from "../inputs/renderTextField";
import PersonFormValidation from "../validation/forms/personFormValidator";
import Button from '@material-ui/core/Button';

const DepartmentForm =  (props) =>{
  const {submitDepartment, handleSubmit, handleCancel} = props;
  return (
    <form onSubmit={handleSubmit(submitDepartment)}>
      <div className={'form-group'}>
        <Field name="name" label={'Name'} component={RenderTextField} type="text" required fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field name="weightOld" min={"0"} step={"0.1"} label={'Εξάμηνη βαρύτητα'} component={RenderTextField} type="number" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field name="weightNew" min={"0"} step={"0.1"} label={'Βαρύτητα νέων καταστημάτων'} component={RenderTextField} type="number" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field name="weightNewComing" min={"0"} step={"0.1"} label={'Βαρύτητα υφιστάμενων καταστημάτων'} component={RenderTextField} type="number" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Button type={'submit'} variant="contained" color="primary" className={'mr-3'}>
          {props.department.id?'Edit':'Create'}
        </Button>
        <Button onClick={handleCancel} variant="contained" color="secondary">
          {'Cancel'}
        </Button>
      </div>
    </form>
  )

};

export default reduxForm({
  enableReinitialize: true,
  form: 'department',
  validate: PersonFormValidation,
})(DepartmentForm);



// WEBPACK FOOTER //
// ./src/components/department/departmentForm.js